export default {
  namespaced: true,
  institutions: {
    title: 'Instituições | instituição',
    name: 'nombre',
    description: 'descrição',
    tenant: 'Tenant',
    institutions: 'Instituições',
    select: 'Selecione uma ou mais instituições'
  }
}
